<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/dashboard" color="error" icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Users</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3 pb-2" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-3 pb-3" xs12>
      <v-layout row wrap justify-center>
        <v-flex xs12 md8>
          <v-text-field
            class="elevation-1"
            label="Search"
            @keyup.enter="search"
            v-model.trim="searchQuery"
            prepend-icon="search"
            :append-icon="searchQuery.length > 0 ? 'close' : ''"
            :append-icon-cb="() => (searchQuery = '', listed = [])"
            solo
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 md10>
      <v-card class="px-2 pb-2" flat>
        <v-layout row wrap justify-center>
          <v-flex v-if="loading" class="py-5 my-5" xs12>
            <div class="text-xs-center display-3 grey--text text--lighten-1">
              <v-progress-circular color="accent" indeterminate></v-progress-circular>
            </div>
          </v-flex>
          <template v-else>
            <v-flex v-if="listed.length == 0" class="py-5 my-5" xs12>
              <div class="text-xs-center display-3 grey--text text--lighten-1">
                {{users.length + ' User'}}{{users.length == 1 ? '' : 's'}}
              </div>
            </v-flex>
            <template v-else>
              <v-flex class="px-2 pb-4 text-xs-center secondary--text title" xs12>
                <div class="title pb-2">
                  <b>{{listed.length}}{{listed.length == 1 ? ' result' : ' results'}}</b>
                </div>
                <div class="subheading">
                  <b>20 users per page</b>
                </div>
              </v-flex>
              <v-flex class="px-2 pb-3" xs12 md8>
                <v-layout row>
                  <v-flex class="text-xs-right" xs>
                    <v-btn
                      @click.native="currentPage = currentPage - 1"
                      class="my-0"
                      color="primary"
                      :disabled="currentPage == 0"
                      icon
                      flat
                    ><b><v-icon medium>chevron_left</v-icon></b>
                    </v-btn>
                  </v-flex>
                  <v-flex xs>
                    <v-menu max-height="300px" full-width offset-y>
                      <v-btn slot="activator" color="primary" class="my-0" flat block>
                        <span><b>Page {{currentPage + 1}}</b></span>
                      </v-btn>
                      <v-list>
                        <template v-for="p, i in pages">
                          <v-list-tile v-if="currentPage == i" :key="i">
                            <v-list-tile-title class="grey--text text--lighten-1">
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile v-else :key="i" @click="currentPage = i">
                            <v-list-tile-title>
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-menu>
                  </v-flex>
                  <v-flex xs>
                    <v-btn
                      @click.native="currentPage = currentPage + 1"
                      class="my-0"
                      color="primary"
                      :disabled="(currentPage + 1) == pages.length"
                      icon
                      flat
                    ><b><v-icon medium>chevron_right</v-icon></b>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-for="user in pages[currentPage]" :key="user.uid" class="px-2 pb-4" xs12 md6>
                <v-card class="pa-2 elevation-1 grey lighten-4">
                  <v-layout row wrap justify-center>
                    <v-flex class="pt-2 text-xs-center" xs12>
                      <span class="secondary--text title"><b>{{user.firstName + ' ' + user.lastName}}</b></span>
                    </v-flex>
                    <v-flex class="text-xs-center" xs12>
                      <span class="secondary--text subheading"><b>{{user.email}}</b></span>
                    </v-flex>
                    <v-flex class="pt-2" xs10>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex class="px-2 pt-2" xs12>
                      <v-layout class="subheading" row wrap>
                        <v-flex class="px-2" xs12>
                          <span><b>Recent Note: </b></span>
                          <span v-if="notes[user.uid].length > 0">{{notes[user.uid][0]}}</span>
                          <span v-else>No notes for this user</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex class="pb-2 text-xs-center" xs12>
                      <v-btn :to="'/users/' + user.uid" color="primary" class="my-0" flat><b>View</b></v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex class="px-2 pb-2" xs12 md8>
                <v-layout row>
                  <v-flex class="text-xs-right" xs>
                    <v-btn
                      @click.native="currentPage = currentPage - 1"
                      class="my-0"
                      color="primary"
                      :disabled="currentPage == 0"
                      icon
                      flat
                    ><b><v-icon medium>chevron_left</v-icon></b></v-btn>
                  </v-flex>
                  <v-flex xs>
                    <v-menu max-height="300px" full-width offset-y top>
                      <v-btn slot="activator" color="primary" class="my-0" flat block>
                        <span><b>Page {{currentPage + 1}}</b></span>
                      </v-btn>
                      <v-list>
                        <template v-for="p, i in pages">
                          <v-list-tile v-if="currentPage == i" :key="i">
                            <v-list-tile-title class="grey--text text--lighten-1">
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile v-else :key="i" @click="currentPage = i">
                            <v-list-tile-title>
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-menu>
                  </v-flex>
                  <v-flex xs>
                    <v-btn
                      @click.native="currentPage = currentPage + 1"
                      class="my-0"
                      color="primary"
                      :disabled="(currentPage + 1) == pages.length"
                      icon
                      flat
                    ><b><v-icon medium>chevron_right</v-icon></b></v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </template>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    searchQuery: '',
    users: [],
    listed: [],
    pages: [],
    notes: {},
    currentPage: 0
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.users = this.$store.getters.users
      for (let i = 0; i < this.users.length; i++) {
        this.notes[this.users[i].uid] = [...this.$store.getters.notesByUser(this.users[i].uid)]
      }
      this.loading = false
    },
    search () {
      this.listed = []
      if (this.searchQuery.length === 0) return
      this.loading = true
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].data.includes(this.searchQuery.toLowerCase())) {
          this.listed.push({...this.users[i]})
        }
      }
      this.pages = []
      let i = 0
      let pageNum = 0
      while (i < this.listed.length) {
        this.pages.push([])
        while (this.pages[pageNum].length < 20) {
          if (i === this.listed.length) break
          this.pages[pageNum].push({...this.listed[i]})
          i++
        }
        pageNum++
      }
      this.currentPage = 0
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserList.vue